import React, { Component } from "react"

class ContactHeroSection extends Component {
  render() {
    return (
      <section id="contact-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="page-title">
                <h1>Contact us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default ContactHeroSection
